import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/thum_img/kp708b/sub4_2/b851f2c11b9930f1b6e6f2983eb81cdf_water__c1_w280_h397.jpg'
import _imports_1 from '@/assets/thum_img/kp708b/sub4_2/b0f6c00a247fa5ecb450d4188d8c2668_water__c1_w280_h397.jpg'
import _imports_2 from '@/assets/thum_img/kp708b/sub4_2/9ad8852443a2316a93fbbd9e94758324_water__c1_w280_h397.jpg'


const _hoisted_1 = { class: "menu-A-list-wrap" }
const _hoisted_2 = { class: "sub04_wrap" }

import { watch } from "vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";

export default /*@__PURE__*/_defineComponent({
  __name: 'Startup_Items',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_n_space = _resolveComponent("n-space")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: `${_unref(USER_ROUTES).Product.Activity.Startup.Startup_e.Path}`
          }, {
            default: _withCtx(() => [
              _createElementVNode("figure", null, [
                _createVNode(_component_n_space, { justify: "center" }, {
                  default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createElementVNode("img", {
                      src: _imports_0,
                      border: "0"
                    }, null, -1)
                  ])),
                  _: 1
                })
              ]),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "bg" }, [
                _createElementVNode("span", null, "VIEW")
              ], -1))
            ]),
            _: 1
          }, 8, ["to"]),
          _cache[2] || (_cache[2] = _createElementVNode("h1", null, "Activity_재능 발견 꿈·창업_초등학생", -1))
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: `${_unref(USER_ROUTES).Product.Activity.Startup.Startup_m.Path}`
          }, {
            default: _withCtx(() => [
              _createElementVNode("figure", null, [
                _createVNode(_component_n_space, { justify: "center" }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createElementVNode("img", {
                      src: _imports_1,
                      border: "0"
                    }, null, -1)
                  ])),
                  _: 1
                })
              ]),
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "bg" }, [
                _createElementVNode("span", null, "VIEW")
              ], -1))
            ]),
            _: 1
          }, 8, ["to"]),
          _cache[5] || (_cache[5] = _createElementVNode("h1", null, "Activity_재능 발휘 꿈·창업_중학생", -1))
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: `${_unref(USER_ROUTES).Product.Activity.Startup.Startup_h.Path}`
          }, {
            default: _withCtx(() => [
              _createElementVNode("figure", null, [
                _createVNode(_component_n_space, { justify: "center" }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createElementVNode("img", {
                      src: _imports_2,
                      border: "0"
                    }, null, -1)
                  ])),
                  _: 1
                })
              ]),
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "bg" }, [
                _createElementVNode("span", null, "VIEW")
              ], -1))
            ]),
            _: 1
          }, 8, ["to"]),
          _cache[8] || (_cache[8] = _createElementVNode("h1", null, "Activity_재능 디자인 꿈·창업_고등학생", -1))
        ])
      ])
    ])
  ]))
}
}

})